import React from 'react';
import { Text, TextLink, Spacing, Row, Column, Grid } from '@dls/web';
import { DocumentInfo } from '@dls/assets/dist/icons/web';
import { openInNewTab } from '../../helpers/common';
import AppFlexBox from '../../styles/app-flex';
import WhatsAppLogo from '@dls/assets/dist/images/web/logo_whatsapp.svg';
import useTranslate from '../../hooks/useTranslation';
import LINKS from '../../config/links';
import styled from 'styled-components';

const StyledWhatsAppIcon = styled(WhatsAppLogo)`
  width: 42px;
  height: 42px;
`;

export const NeedHelpSection = () => {
  const { t } = useTranslate();
  const handleFAQClick = () => {
    openInNewTab(LINKS.faq);
  };

  const handleWhatsAppClick = () => {
    openInNewTab(LINKS.mobileWhatsAppContactLink);
  };

  return (
    <Spacing top={2} bottom={4} left={0} right={0}>
      <Grid>
        <Row noGutter>
          <Column noGutter>
            <Text type="header" tag="h4">
              {t('NEED_HELP')}
            </Text>
            <Spacing top={2}>
              <AppFlexBox gap="8px" alignItems="center">
                <DocumentInfo size={40} color="#0066CC" />
                <TextLink onClick={handleFAQClick}>
                  {t('READ_FULL_FAQ')}
                </TextLink>
              </AppFlexBox>
            </Spacing>

            <Spacing top={1}>
              <AppFlexBox gap="8px" alignItems="center">
                <StyledWhatsAppIcon
                  data-testid={`whatsapp-icon`}
                  onClick={handleWhatsAppClick}
                ></StyledWhatsAppIcon>
                <TextLink onClick={handleWhatsAppClick}>
                  {t('CHAT_WITH_US')}
                </TextLink>
              </AppFlexBox>
            </Spacing>
          </Column>
        </Row>
      </Grid>
    </Spacing>
  );
};

export default NeedHelpSection;
